import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import Logo from '../images/logo.png'
import Footer from '../components/Footer';
import Users from '../data/Users.json'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { login } from '../slice/userSlice';


export default function SignupForm() {
    const colo = useSelector((state) => state.theme)

    
    const navigate = useNavigate();
    const dispatch = useDispatch();


    const formik = useFormik({
        initialValues: {
            email: '',
            username: '',
            password: '',
            confirmPassword: '',
        },
        validationSchema: Yup.object({
            username: Yup.string()

                .max(17, 'پێویستە لە ١٧ پیت یان کەمتربێت')
                .required('یوزەرنەیم داخڵبکە '),

            email: Yup.string()
                .email('ئیمەیڵەکەت هەڵەیە')
                .required('ئیمەیڵ داخڵبکە'),
            password: Yup.string()
                .required('پاسۆرد داخڵبکە')
                .min(6, 'پاسۆرد پیویستە لە ٦ پیت کەمتر نەبێت')
                .max(30, 'پاسۆرد پیویستە لە ٣٠ پیت زیاتر نەبێت'),
            confirmPassword: Yup.string()
                .required('دڵنیاکردنەوەی پاسۆرد پێویستە')
                .oneOf([Yup.ref('password'), null], 'پاسۆردەکان وەک یەکنین'),
        }),

        onSubmit: (values) => {
            
            const newuser = {
                "id": Users.length + 1,
                "userName": `${values.username}`,
                "email": `${values.email.toLowerCase()}`,
                "password": `${values.password}`,
                "userImage": `https://i1.sndcdn.com/avatars-000255771415-dx5rag-t500x500.jpg`,
                "userRole": "normaluser"
            }
            Users.push(newuser)
            dispatch(login(newuser));
            navigate('/home', { replace: true });

        },
    });


    return (
        <>
            <div className={`${colo.theme} bg-dwam h-full min-h-screen flex items-center justify-center py-9 px-4 sm:px-6 lg:px-8`}>
                <div className='max-w-md w-full space-y-3 sm:outline  sm:outline-chwaram sm:rounded-md shadow-2xl p-2 '>
                    <div>
                        <Link to='/home'>
                            <img className="block mx-auto h-16 w-16" src={Logo} alt="logo" />
                        </Link>
                        <h2 className="mt-6 text-center text-3xl font-extrabold text-yakam"> هەژمار دروستبکە</h2>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <label htmlFor="username">ناو</label>
                        <input
                            id="username"
                            name="username"
                            type="text"
                            className='border-2 border-dwam text-chwaram text-sm rounded-lg focus:ring-yakam focus:border-yakam block w-full p-2.5 bg-yakam  placeholder-dwam   '
                            required
                            {...formik.getFieldProps('username')}
                        />
                        {formik.errors.username ? (
                            <p className="text-red-800 p-1 drop-shadow-lg"> {formik.errors.username}</p>
                        ) : null}
                        
                        <label htmlFor="email">هەژماری ئەلیکترۆنی</label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            className='border-2 border-dwam text-chwaram text-sm rounded-lg focus:ring-yakam focus:border-yakam block w-full p-2.5 bg-yakam  placeholder-dwam   '
                            {...formik.getFieldProps('email')}
                        />
                        {formik.touched.email && formik.errors.email ? (
                            <p className="text-red-800 p-1 drop-shadow-lg"> {formik.errors.email}</p>
                        ) : null}
                        <label htmlFor="password">وشەی نهێنی</label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            className='border-2 border-dwam text-chwaram text-sm rounded-lg focus:ring-yakam focus:border-yakam block w-full p-2.5 bg-yakam  placeholder-dwam   '
                            {...formik.getFieldProps('password')}
                        />
                        {formik.touched.password && formik.errors.password ? (
                            <p className="text-red-800 p-1 drop-shadow-lg"> {formik.errors.password}</p>
                        ) : null}
                        <label htmlFor="confirmPassword">دڵنیاکردنەوەی وشەی نهێنی</label>
                        <input
                            id="confirmPassword"
                            name="confirmPassword"
                            type="password"
                            className='border-2 border-dwam text-chwaram text-sm rounded-lg focus:ring-yakam focus:border-yakam block w-full p-2.5 bg-yakam  placeholder-dwam   '
                            {...formik.getFieldProps('confirmPassword')}
                        />
                        {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                            <p className="text-red-800 p-1 drop-shadow-lg"> {formik.errors.confirmPassword}</p>
                        ) : null}

                        <button
                            type='submit'
                            className="shadow-sm shadow-penjam relative inline-flex items-center justify-center mt-3 w-full overflow-hidden text-sm font-medium text-chwaram rounded-lg group bg-gradient-to-br from-penjam to-chwaram group-hover:from-penjam group-hover:to-chwaram hover:text-black  focus:ring-4 focus:outline-none focus:ring-green-200 "

                        >
                            <span className="shadow-sm shadow-penjam relative w-full px-5 py-2.5 transition-all ease-in duration-75 bg-yakam  rounded-md group-hover:bg-opacity-0">
                                دروستبکە
                            </span>
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </>
    );
}
